import { useSelector } from "react-redux";
import { useQuery, useMutation, useQueryClient } from "react-query";
import {
  listDuplicatePlayerApprovalRequests,
  resolveDuplicatePlayerApprovalRequest,
} from "../../config/mainRequest";

const KEY = ["duplicate-player", "approval-requests"];

/**
 * Admin / Privileged approval inbox (duplicate-flow spec §11 / §13).
 * The endpoint 403s for everyone else — the caller surfaces that as a notice.
 */
export function useDuplicateApprovals() {
  const token = useSelector((state) => state.auth.token);
  const qc = useQueryClient();

  const list = useQuery(KEY, () => listDuplicatePlayerApprovalRequests({ token }), {
    enabled: !!token,
    retry: false,
  });

  const resolve = useMutation(
    ({ requestId, approve }) =>
      resolveDuplicatePlayerApprovalRequest({ requestId, approve, token }),
    { onSuccess: () => qc.invalidateQueries(KEY) }
  );

  return { list, resolve };
}
